import { SiteItemData, SiteVideoData } from "../../../../interfaces";
import { SiteVideoInline } from "../../../../siteWidgets/videoPlayer/genericInlineVideoPlayer/siteVideoInline";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";

interface VideoVerticalFeedItemMutamProps {
    videoItem: SiteItemData & { hidePrerollAds?: boolean, prerollIndex?: number }
    initialFeedSlide: number
    feedActiveSlide: number
    feedIndex: number
    arrowDisplay: string
    domain: string
    index: number
    isTitleVisible: boolean
    isSubTitleVisible: boolean
    showPrerollAds: boolean
    onCloseVideoGalleryView: () => void
    onNextSlide: () => void
}

interface VideoVerticalFeedItemMutamState {
    isSubtitleOpen: boolean
}

const DICT = {
    nextVideo: "לוידאו הבא",
    fullArticle: "לכתבה המלאה",
}

export class VideoVerticalFeedItemMutam extends React.Component<VideoVerticalFeedItemMutamProps, VideoVerticalFeedItemMutamState>{
    constructor(props) {
        super(props);
        this.state = {
            isSubtitleOpen: false,
        }
    }

    componentDidMount() {
        this.initializeEndedEventListeners();
    }

    componentWillUnmount() {
        this.removeEndedEventListeners();
    }

    private initializeEndedEventListeners() {
        setTimeout(() => {
            const videoElements = document.querySelectorAll(".calcalistVideoGalleryVerticalMutamComponenta .feedDisplay .slick-slide .videoVerticalFeedItemMutam #player .fp-engine") as NodeListOf<HTMLVideoElement>;
            if (videoElements.length) {
                videoElements.forEach((element) => {
                    element.addEventListener("ended", this.handleVideoEnded);
                })
            };
        }, 600)
    }

    private removeEndedEventListeners() {
        const videoElements = document.querySelectorAll(".calcalistVideoGalleryVerticalMutamComponenta .feedDisplay .slick-slide .videoVerticalFeedItemMutam #player .fp-engine") as NodeListOf<HTMLVideoElement>;
        if (videoElements.length) {
            videoElements.forEach((element) => {
                element.removeEventListener("ended", this.handleVideoEnded)
            })
        };
    }

    private handleVideoEnded = (e) => {
        e.target.currentTime = 0;
        e.target.click();
        this.props.onNextSlide();
    }

    private onSubtitleModeToggle = () => {
        this.setState({ isSubtitleOpen: !this.state.isSubtitleOpen });
    }

    private pushGA4Event = () => {
        if (typeof window == "undefined" || !window.dataLayer) return;
        const { index } = this.props;

        window.dataLayer.push({
            event: "content_click",
            componenta_name: "vertical_video",
            content_type: "componenta",
            position_in_component: index,
            click_text: "לכתבה המלאה"
        });
    };

    private openShare = async () => {
        const { domain, videoItem: { media } } = this.props;
        const shareUrl = `${domain}/video/${(media as SiteVideoData).videoPageId}?utm_source=ynet.co.il&utm_medium=Share&utm_campaign=copy_url&utm_content=vertical_video`;
        const shareData = { url: shareUrl };
        try {
            // @ts-ignore 
            await navigator.share(shareData)
        } catch (err) {
            console.log("error with sharing function", err);
        }
    }

    public render() {
        const { isSubtitleOpen } = this.state;
        const { videoItem, onCloseVideoGalleryView, arrowDisplay, onNextSlide, isTitleVisible, isSubTitleVisible, showPrerollAds, index, feedActiveSlide } = this.props;
        const { media, title, subTitle, titleLink, titleTargetLink } = videoItem;
        const subtitleClass = `videoSubtitle ${isSubtitleOpen ? "" : "close"}`;
        const feedItemClass = `videoVerticalFeedItemMutam ${isSubtitleOpen ? "openMode" : "standardMode"}`;
        const shouldDisplayVideo = (feedActiveSlide === index || feedActiveSlide === index - 1 || feedActiveSlide === index + 1);
        const videoPageId = (media as SiteVideoData).videoPageId;

        return (
            <div className={feedItemClass}>
                {shouldDisplayVideo &&
                    <SiteVideoInline
                        data={media as SiteVideoData}
                        applyStickyness={true}
                        hideVideoAds={showPrerollAds ? videoItem.hidePrerollAds : true}
                        adIndex={videoItem.prerollIndex}
                        isShareButton={false} />
                }
                <div className={`arrow arrowNext ${arrowDisplay}`} onClick={onNextSlide}>{DICT.nextVideo}</div>
                <div className="closeBtn" onClick={onCloseVideoGalleryView}></div>
                {videoPageId &&
                    <div className="shareBtnWrapper">
                        <div className="shareBtn" onClick={this.openShare}></div>
                    </div>
                }
                <div className="contentDiv">
                    {isTitleVisible && <div className="videoTitle" dangerouslySetInnerHTML={{ __html: title }} />}
                    {isSubTitleVisible && <div className={subtitleClass} onClick={this.onSubtitleModeToggle} dangerouslySetInnerHTML={{ __html: subTitle }} />}
                    {titleLink &&
                        <div onClick={this.pushGA4Event}>
                            <HyperLinkBuilder
                                className="videoLink"
                                href={titleLink}
                                linkTarget={titleTargetLink}
                            >
                                {DICT.fullArticle}
                            </HyperLinkBuilder>
                        </div>
                    }
                </div>
            </div>
        )
    }
}